export default {
  label: {
    placeholder: {
      dashboardSelect: 'Select a dashboard',
    },
    title: {
      welcomeMessage: 'Hello',
      infoMessage: 'Let\'s get to know each other a little more to personalize your experience!',
      firstStepMessage: 'To start, tell us a little about yourself.',
      dashboardSelectionMessage: 'Here you can find your dashboards.',
      noTitleDasboard: 'Dashboard without title',
      requiredMessage: '* The fields below are required.',
      department: 'Department',
      job: 'Job',
      selectDashboard: 'Dashboards',
      newDepartment: 'New Department',
      newJob: 'New Job',
      others: 'Others',
      finishMessage: 'That\'s it! Now you have everything to make history.',
      haveFunMessage: 'And don\'t forget to have fun too ;)',
      useCaseMessage: 'What type of use do you make of Stilingue products?',
      mustChooseUseCaseMessage: 'You need to choose at least one use case to continue with the onboarding.',
      notFoundUseCaseMessage: 'If you haven\'t found it above.',
      writeHereMessage: 'Write here',
      dashboardModelsMessage: 'Great! These are the dashboard models for you.',
      emptyDashboardMessage: 'You can also start with a blank dashboard if you prefer.',
      indicatedForMessage: 'Indicated for',
      chooseDashboardNameMessage: 'What would you like to name your dashboard?',
      chooseDashboardNameLaterMessage: 'You can do this later if you prefer.',
      exploreMessage: 'Explore',
      closeMessage: 'Close View',
    },
    button: {
      startFormButton: 'Let\'s go',
      nextButton: 'Next',
      previousButton: 'Previous',
      lastButtonLabel: 'Make history with @:systemName',
    },
  },
  identifier: {
    step: {
      userAndCompany: 'User and Company',
      stiUseCases: 'STI Use Cases',
      dashboardsTemplates: 'Dashboard Models',
      dashboardName: 'Dashboard Name',
      dashboardSelection: 'Dashboard Selection',
    },
  },
};
